/* Global imports. */
import React from "react";

/* Imports from within current directory. */
import { convertKontentImageURLToImageKitURL } from "@src/imagekit";

/* Other imports. */
import placeholder from "@images/placeholder--article.jpg";

interface Props {
  image: string;
  format: "large" | "portrait" | "landscape";
}

const ArticleCardBackgroundImage = ({ image, format }: Props) => {
  const sourceFile = image ? convertKontentImageURLToImageKitURL(image) : placeholder;

  return (
    <span className={`${format == 'landscape' ? 'w-[140px] h-[98px] sm:w-[300px] sm:h-[146px]' : 'sm:w-full h-[200px] md:h-[300px]'} bg-center bg-cover block`} >
        <img
            className="w-full h-full object-cover"
            alt="Article background"
            src={sourceFile}

        />
      </span>
  );
};

export default ArticleCardBackgroundImage;
